<div class="issue-detail-sidenav">
  <!-- Sticky header: title + close -->
  <div class="sticky-header">
    <div class="header-row">
      <div class="heading text-type-2">
        {{ loadedIssue?.title || 'Warranty Issue' }}
      </div>
      <button class="close-btn" (click)="onClose()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    @if (subHeaderChips.length) {
      <div class="sub-chips-row">
        @for (chip of subHeaderChips; track chip) {
          <div class="sub-chip">{{ chip }}</div>
        }
      </div>
    }

    <div class="chips-row">
      @if (loadedIssue?.status && statusMap[loadedIssue.status]) {
        <div
          [ngClass]="[statusMap[loadedIssue.status].bgColor, statusMap[loadedIssue.status].textColor]"
          class="status-chip px-[10px] rounded-full">
          {{ statusMap[loadedIssue.status].label }}
        </div>
      }
      @if (loadedIssue?.type) {
        <div class="status-chip px-[10px] rounded-full type-chip">{{ loadedIssue.type }}</div>
      }
    </div>
  </div>

  <!--
    Contractor workflow (projects with issue_workflow_enabled): the panel lays
    the issue out like the punch list item detail — a Details tab with the
    description and media and the action pick list, and a Discussion tab.
    The status is the chip in the header above. Anywhere else it renders
    them as they are.
  -->
  <app-issue-workflow-panel
    (issueChanged)="onWorkflowChange($event)"
    [issue]="loadedIssue"
    [projectId]="projectId"
    [showStatus]="false"
    >
  @if (loadedIssue?.description) {
    <div class="issue-description-text">{{ loadedIssue.description }}</div>
  }

  @if (mediaItems.length) {
    <div class="section">
      <div class="section-head">
        <div class="label">Media</div>
        @if (pictureItems.length) {
          <button class="download-all-btn" (click)="downloadAllPictures()" type="button">
            <mat-icon>download</mat-icon>
            <span>Download all</span>
          </button>
        }
      </div>
      <div class="media-grid">
        @for (picture of mediaItems; track picture.id) {
          <div class="picture-block">
            <app-image
              (click)="appService.openCarousel($event, mediaItems, picture, false)"
              [url]="picture.thumb_url || picture.original_url"
              class="each-picture"
            />
          </div>
        }
      </div>
    </div>
  }
  </app-issue-workflow-panel>
</div>
